import { gsap } from "gsap";
import { horizontalLoop } from '../snippets/horizontalLoop'

export default class SmallStripBanner {
    constructor(container) {
        this.container = container;
        this.track = this.container.querySelector('[data-banner-track]');
        this.items = gsap.utils.toArray('.small-strip-banner__item');

        if (this.items.length > 0) {
            this.init();
        }
    }

    init = () => {
        this.loop = horizontalLoop(this.items, { gap: 0, paused: false, reversed: false, draggable: false, center: false, repeat: -1, speed: 0.7 });

        if (window.lenis) {
            window.lenis.on('scroll', this.onScroll);
        }
    }

    onScroll = ({ scroll, limit, velocity, direction, progress }) => {
        if (direction == 0) return;
        gsap.set(this.loop, { duration: 0, timeScale: direction * Math.abs(velocity) / 10 + direction });
    }
}

